import { render, staticRenderFns } from "./CampoContrasena.vue?vue&type=template&id=6045caf8&"
import script from "./CampoContrasena.vue?vue&type=script&lang=ts&"
export * from "./CampoContrasena.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports